import { Box, Button, Center, Flex, FormControl, FormErrorMessage, FormLabel, Grid, Img, InputGroup, Spinner, Stack, Text, VStack, useToast } from "@chakra-ui/react";
import CryptoJS from "crypto-js";
import { format } from "date-fns";
import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Loader from "react-loader-spinner";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { InputControl, SelectControl } from "../../components/Controls";
import { useAuth } from "../../plugins/CookieAuthPlugin";
import { toAbsoluteUrl, toastGenerator } from "../../utils/helper";
import { useAddFormScanMutation, useGetDurationScanDropDown, useGetProvinceScanDropDown, useGetPurposeScanDropDown, useGetTransportationScanDropDown } from "../../utils/hooks/formScan";
import useGeoLocation from "../../utils/hooks/location";
import './style.css';
import { translateEN, translateKH } from "./translation";

function FormScan() {
    const { pathname } = useLocation();
    const [zoneCode, setZoneCode] = useState("");
    const history = useHistory();
    const [Result, setResult] = useState({});
    const isEn = JSON.parse(localStorage.getItem("isEn")) | false;
    const [isKh, setIsKh] = useState(!isEn);
    const [translation, setTranslation] = useState({});
    const userLocation = useGeoLocation();
    const { user, logout } = useAuth();
    const toast = useToast();
    const [isAmountPeopleWrong, setAmountPeopleWrong] = useState(false);
    const { control, handleSubmit, reset } = useForm({ defaultValues: { numUnder12: 0, num12to25: 0, num25to59: 0, numAbove60: 0 } });

    useEffect(() => {
        setZoneCode(pathname.split("/")[2])
        user && logout();
        localStorage.removeItem("qr-code");
        // eslint-disable-next-line
    }, []);

    // retrieve the JSON data from LocalStorage
    useEffect(() => {
        const data = localStorage.getItem('visit_angkor_scan_form_qrcode');
        if (data !== null) {
            var parsedData = JSON.parse(data);
            let form = {
                province: parsedData.provice,
                numberOfPeople: parsedData.people,
                numUnder12: parsedData.under12Year,
                num12to25: parsedData.age12To25Year,
                num25to59: parsedData.age26To59Year,
                numAbove60: parsedData.age60YearUp,
                duration: parsedData.duration,
                purpose: parsedData.purposeOfVisit,
                transportation: parsedData.transportation,
            }
            reset(form)
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (userLocation.error.code === 1) {
            toast({ status: "warning", position: "top", title: translation["pleaseAllow"], isClosable: true });
        }
    }, [userLocation, toast, translation]);

    useEffect(() => {
        isKh ? setTranslation(translateKH) : setTranslation(translateEN);
        localStorage.setItem("isEn", !isKh ? "true" : "false");
    }, [isKh]);
    const handleLanguageChange = () => {
        reset({ numUnder12: 0, num12to25: 0, num25to59: 0, numAbove60: 0, province: null, numberOfPeople: "", duration: null, purpose: null, transportation: null });
        setIsKh(!isKh)
    };
    const provinceDropDown = useGetProvinceScanDropDown({ payload: { page: 1, rowsPerPage: 1000, isKh: isKh } });
    const durationDropDown = useGetDurationScanDropDown({ payload: { page: 1, rowsPerPage: 1000, isKh: isKh } });
    const transportationDropDown = useGetTransportationScanDropDown({ payload: { page: 1, rowsPerPage: 1000, isKh: isKh } });
    const purposeOfVisitDropDown = useGetPurposeScanDropDown({ payload: { page: 1, rowsPerPage: 1000, isKh: isKh } });
    const addFormScanMutation = useAddFormScanMutation({
        onSuccess(data) {
            if (data) {
                if (data.body.status) {
                    localStorage.setItem("qr-code", JSON.stringify(Result));
                    history.push(`${pathname}/form-success`);
                } else {
                    history.push(`${pathname}/out-of-zone`);
                }
            }
        },
        onError() {
            toast(toastGenerator({ status: "error" }));
        },
    });

    const onSubmit = useCallback((values) => {
        const numAge = {
            ageUnder12: parseInt(values.numUnder12),
            age12To25Year: parseInt(values.num12to25),
            age26To59Year: parseInt(values.num25to59),
            age60YearUp: parseInt(values.numAbove60),
        }
        const date = new Date();
        const totalPPL = parseInt(values.numberOfPeople);
        const isPeopleEqual = totalPPL === Object.values(numAge).reduce((a, c) => a + c, 0);
        // interrupt submitting
        if (!isPeopleEqual) {
            setAmountPeopleWrong(!isPeopleEqual);
            return;
        }
        const uniqueCode = CryptoJS.MD5(Date.now().toString() + 1 + 199).toString().slice(0, 13);

        if (userLocation.loaded) {
            const payload = {
                under12Year: numAge.ageUnder12,
                age12To25Year: numAge.age12To25Year,
                age26To59Year: numAge.age26To59Year,
                age60YearUp: numAge.age60YearUp,
                lat: userLocation.coordinates.lat.toString()/*  "11.567516" */,
                lng: userLocation.coordinates.lng.toString()/*  "104.894346" */,
                visitorCode: uniqueCode,
                zoneCode: zoneCode,
                provinceId: values.province.value,
                durationId: values.duration.value,
                purposeOfVisitId: values.purpose.value,
                transportationId: values.transportation.value,
                people: totalPPL,
                datetimeScan: format(date, "yyyy-MM-dd HH:m:ss"),
            };
            setResult({
                ...values,
                visitorCode: uniqueCode,
                datetimeScan: date,
            });
            addFormScanMutation.mutate(payload);
        }
        const dataForm = {
            people: totalPPL,
            provice: values.province,
            under12Year: numAge.ageUnder12,
            age12To25Year: numAge.age12To25Year,
            age26To59Year: numAge.age26To59Year,
            age60YearUp: numAge.age60YearUp,
            duration: values.duration,
            purposeOfVisit: values.purpose,
            transportation: values.transportation,
        }
        localStorage.setItem('visit_angkor_scan_form_qrcode', JSON.stringify(dataForm))
    }, [userLocation, addFormScanMutation, zoneCode]);

    return (
        <>
            <Center columns={{ md: 2, sm: 1 }} h="100vh" bg="gray.100">
                <Box backgroundSize="cover"
                    backgroundPosition="center top" backgroundAttachment={"fixed"} backgroundImage={`url("${toAbsoluteUrl("/assets/form-qr-bg.png")}")`} bgRepeat="no-repeat" w={{ xl: "30vw", lg: "40vw", md: "50vw", sm: "100%", base: "100%" }} h={{ xl: "90vh", lg: "90vh", md: "90vh", sm: "100%", base: "100%" }} overflow="scroll" borderRadius="10">
                    <VStack>
                        <Flex bg={"white"} zIndex={"1400"} pos={"sticky"} top={"0"} flexDir={"row"} alignItems={"center"} justifyContent={"center"} textAlign="center" w={"100%"} p={3} boxShadow={"sm"} >
                            <Box width={"50%"} fontFamily={isKh && "moul"} fontWeight={!isKh && "700"} >
                                {translation["questionnaire"]}
                            </Box>
                            <Button position="absolute" bg={"rgb(102, 51, 51,0.4)"} border={"1px solid rgb(102,51,51)"} p={1} right={"10px"} onClick={() => handleLanguageChange()}>
                                {isKh ? <Img src={toAbsoluteUrl("/assets/en_flag.png")} width={"30px"} /> :
                                    <Img src={toAbsoluteUrl("/assets/kh_flag.png")} width={"30px"} />}
                                <Text px={2}>{isKh ? "ENG" : " ខ្មែរ "}</Text>
                            </Button>
                        </Flex>
                        <Box zIndex="banner" w={{ base: "85%", md: "90%" }} as="form" onSubmit={handleSubmit(onSubmit)} fontFamily={"kh"}>
                            <Stack spacing="5">
                                <FormControl id="province">
                                    <FormLabel color="gray.600" pb={"1"} fontWeight="normal" fontSize={"110%"}>
                                        {translation["province"]}
                                    </FormLabel>
                                    <InputGroup>
                                        <SelectControl
                                            name="province"
                                            placeholder={translation["find"]}
                                            isclearable="true"
                                            isRequired
                                            className="selectControl"
                                            control={control}
                                            isLoading={provinceDropDown.isLoading}
                                            options={provinceDropDown.data}
                                        />
                                    </InputGroup>
                                </FormControl>
                                <FormControl id="numOfPeople" isInvalid={isAmountPeopleWrong}>
                                    <FormLabel color="gray.600" pb={"1"} fontWeight="normal" fontSize={"110%"}>
                                        {translation["people"]}
                                    </FormLabel>
                                    <InputGroup>
                                        <InputControl
                                            name="numberOfPeople"
                                            placeholder={translation["input"]}
                                            isRequired
                                            min="0"
                                            inputmode="numeric"
                                            pattern="[0-9]*"
                                            control={control}
                                        />
                                    </InputGroup>
                                    <Center>
                                        <FormErrorMessage>{translation["notEqual"]}</FormErrorMessage>
                                    </Center>
                                </FormControl>
                                <Box>
                                    <Text color="gray.600" pb={"1"} fontWeight="normal" fontSize={"110%"}>
                                        {translation["age"]}
                                    </Text>
                                    <FormControl isInvalid={isAmountPeopleWrong} >
                                        <Grid templateColumns='repeat(2, 1fr)' gap={3} px={2} pb={2} border={isAmountPeopleWrong ? "solid 1px red" : ""} borderRadius={"md"} >
                                            <FormControl pos={"relative"}>
                                                <FormLabel color="gray.600" pb={"1"} fontWeight="normal" fontSize={"100%"}>
                                                    {translation["under12"]}
                                                </FormLabel>
                                                <InputGroup>
                                                    <InputControl
                                                        name="numUnder12"
                                                        placeholder={translation["Input"]}
                                                        isRequired
                                                        isclearable="true"
                                                        type="number"
                                                        inputmode="numeric"
                                                        pattern="[0-9]*"
                                                        control={control}
                                                    />
                                                    <Box textAlign="center" alignItems={"center"} bg="gray.100" p={2} borderRightRadius={"md"} pos={"absolute"} height={"40px"} right={"0"}>
                                                        {translation["headCount"]}
                                                    </Box>
                                                </InputGroup>
                                            </FormControl>
                                            <FormControl id="numOfPeopleByAge">
                                                <FormLabel color="gray.600" pb={"1"} fontWeight="normal" fontSize={"100%"}>
                                                    {translation["from12to25"]}
                                                </FormLabel>
                                                <InputGroup>
                                                    <InputControl
                                                        name="num12to25"
                                                        placeholder={translation["Input"]}
                                                        isclearable="true"
                                                        min="0"
                                                        isRequired
                                                        inputmode="numeric"
                                                        pattern="[0-9]*"
                                                        type="number"
                                                        control={control}
                                                    />
                                                    <Box textAlign="center" alignItems={"center"} bg="gray.100" p={2} borderRightRadius={"md"} pos={"absolute"} height={"40px"} right={"0"}>
                                                        {translation["headCount"]}
                                                    </Box>
                                                </InputGroup>
                                            </FormControl>
                                            <FormControl id="numOfPeopleByAge">
                                                <FormLabel color="gray.600" pb={"1"} fontWeight="normal" fontSize={"100%"}>
                                                    {translation["from25to59"]}
                                                </FormLabel>
                                                <InputGroup>
                                                    <InputControl
                                                        name="num25to59"
                                                        placeholder={translation["Input"]}
                                                        isclearable="true"
                                                        min="0"
                                                        inputmode="numeric"
                                                        pattern="[0-9]*"
                                                        isRequired
                                                        type="number"
                                                        control={control}
                                                    />
                                                    <Box textAlign="center" alignItems={"center"} bg="gray.100" p={2} borderRightRadius={"md"} pos={"absolute"} height={"40px"} right={"0"}>
                                                        {translation["headCount"]}
                                                    </Box>
                                                </InputGroup>
                                            </FormControl>
                                            <FormControl >
                                                <FormLabel color="gray.600" pb={"1"} fontWeight="normal" fontSize={"100%"}>
                                                    {translation["above60"]}
                                                </FormLabel>
                                                <InputGroup>
                                                    <InputControl
                                                        name="numAbove60"
                                                        isclearable="true"
                                                        placeholder={translation["input"]}
                                                        isRequired
                                                        inputmode="numeric"
                                                        pattern="[0-9]*"
                                                        min="0"
                                                        type="number"
                                                        control={control}
                                                    />
                                                    <Box textAlign="center" alignItems={"center"} bg="gray.100" p={2} borderRightRadius={"md"} pos={"absolute"} height={"40px"} right={"0"}>
                                                        {translation["headCount"]}
                                                    </Box>
                                                </InputGroup>
                                            </FormControl>
                                        </Grid>

                                        <Center>
                                            <FormErrorMessage>{translation["notEqual"]}</FormErrorMessage>
                                        </Center>


                                    </FormControl>
                                    <FormControl id="province" pb={"5"}>
                                        <FormLabel color="gray.600" pb={"1"} fontWeight="normal" fontSize={"110%"}>
                                            {translation["duration"]}
                                            <Text color="red.400"></Text>
                                        </FormLabel>
                                        <InputGroup>
                                            <SelectControl
                                                name="duration"
                                                placeholder={translation["choose"]}
                                                isclearable="true"
                                                isRequired
                                                menuPlacement="top"
                                                className="selectControl"
                                                control={control}
                                                options={durationDropDown.data}
                                            />
                                        </InputGroup>
                                    </FormControl>
                                    <FormControl id="province" pb={"5"}>
                                        <FormLabel color="gray.600" pb={"1"} fontWeight="normal" fontSize={"110%"}>
                                            {translation["purpose"]}
                                        </FormLabel>
                                        <InputGroup>
                                            <SelectControl
                                                name="purpose"
                                                placeholder={translation["choose"]}
                                                className="selectControl"
                                                isclearable="true"
                                                isRequired
                                                menuPlacement="top"
                                                control={control}
                                                options={purposeOfVisitDropDown.data}
                                            />
                                        </InputGroup>
                                    </FormControl>
                                    <FormControl id="province">
                                        <FormLabel color="gray.600" pb={"1"} fontWeight="normal" fontSize={"110%"}>
                                            {translation["transportation"]}
                                        </FormLabel>
                                        <InputGroup>
                                            <SelectControl
                                                name="transportation"
                                                placeholder={translation["choose"]}
                                                isRequired
                                                className="selectControl"
                                                menuPlacement="top"
                                                isclearable="true"
                                                control={control}
                                                options={transportationDropDown.data}
                                            />
                                        </InputGroup>
                                    </FormControl>
                                </Box>
                                {userLocation.error.code === 1 ? <Text fontSize={10} textAlign={"center"}>{translation["pleaseAllow"]}</Text> : null}
                                {!userLocation.loaded && userLocation.error.code === "" ? <Text fontSize={10} textAlign={"center"}><Spinner size="xs" />{translation["wait"]}</Text> : null}
                                <Button colorScheme="none" disabled={(!userLocation.loaded) || (userLocation.error.code === 1)} pos={"relative"} type="submit"
                                    isLoading={addFormScanMutation.isLoading} spinner={<Loader type="ThreeDots" color="#fff" height={40} width={40} />} bg={"#663333"} color={"white"} fontFamily={isKh && "moul"}>
                                    {translation["save"]}
                                    <Img pos={"absolute"} right={"0"} src={toAbsoluteUrl("/assets/flower.svg")} />
                                    <Img pos={"absolute"} left={"0"} transform={"rotate(180deg)"} src={toAbsoluteUrl("/assets/flower.svg")} />
                                </Button>
                            </Stack>
                        </Box>
                    </VStack>
                </Box>
            </Center>
        </>
    );
}

export default FormScan;
